import { Component, OnInit } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { CardInfo } from '../../models/card-info';
import { GetCardInfoForm } from '../../models/forms';
import { HttpError } from 'app/static/http-error';
import { SnackbarService } from 'app/services/snackbar/snackbar.service';
import { GetCardInfoResponse } from '../../models/api-response';
import { API_RESPONSE_CODES } from 'app/static/api';
import { CardInfoDataService } from 'app/services/data/card-info-data.service';
import { ChargeHttpService } from 'app/services/api/charge-http.service';

@Component({
  selector: 'app-payment-info',
  templateUrl: './payment-info.component.html',
  styleUrls: ['./payment-info.component.scss'],
})
export class PaymentInfoComponent implements OnInit {

  cardInfo: CardInfo;

  isWaiting: boolean;

  isSubmitting: boolean;

  private routeParams: { cardno: string };

  constructor(
    private readonly cardInfoDataService: CardInfoDataService,
    private readonly chargeHttp: ChargeHttpService,
    private readonly snackbar: SnackbarService,
    private readonly route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.getRouteParams();
    this.getCardInfo();
  }

  onFormSubmit(event: boolean): void {
    this.isSubmitting = event;
  }


  private getRouteParams() {
    this.route.paramMap
      .subscribe(params => this.routeParams = { ...params['params'] });
  }


  private getCardInfo() {
    this.cardInfoDataService.getCardInfo()
      .pipe(distinctUntilChanged())
      .subscribe(
        data => {
          if (data) {
            this.cardInfo = data;
          } else {
            this.isWaiting = true;
            // if data is null, fetch cardinfo from server
            this.getCardInfoFromApi();
          }
        }
      );
  }


  private getCardInfoFromApi() {
    const data: GetCardInfoForm = { cardno: this.routeParams.cardno };

    this.chargeHttp.getCardInfo(data)
      .subscribe(
        res => this.onGetCardInfoResponse(res),
        (err: HttpError) => this.onGetCardInfoError(err),
        () => this.onGetCardInfoSubscriptionComplete()
      );
  }

  private onGetCardInfoResponse(res: GetCardInfoResponse): void {
    if (res.status === API_RESPONSE_CODES.SUCCESS) {
      this.cardInfo = res.data;
      this.cardInfoDataService.setCardInfo(res.data);
    } else {
      this.snackbar.default(res.message);
    }
  }


  private onGetCardInfoError(err: HttpError): void {
    this.snackbar.default(err.message);
    this.isWaiting = false;
  }


  private onGetCardInfoSubscriptionComplete(): void {
    this.isWaiting = false;
  }

}
